import { render, staticRenderFns } from "./taskToCopyTo.vue?vue&type=template&id=3eced622&"
import script from "./taskToCopyTo.vue?vue&type=script&lang=js&"
export * from "./taskToCopyTo.vue?vue&type=script&lang=js&"
import style0 from "./taskToCopyTo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports